// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-build-1747030333222." + "0c625cf35a3d4766" + ".js";
};